import {  bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import Component from './SignIn';
import * as Actions from '../../../actions/User/SignIn';


const mapStateToProps = (state) => {
  return state
};

const mapDispatchToProps = (dispatch) => (bindActionCreators(Actions, dispatch));


const Container = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Component);

export default withRouter(Container);


// WEBPACK FOOTER //
// ./src/components/User/SignIn/SignInContainer.js